import { render, staticRenderFns } from "./CreateDynamicModules.vue?vue&type=template&id=30c75b77&v-on-clickaway=cancel&"
import script from "./CreateDynamicModules.vue?vue&type=script&lang=ts&"
export * from "./CreateDynamicModules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports